import axios from '../../axios/ctiConfig';
import ctiRequest from '../../axios/ctiRequests';
import * as actionTypes from './actionTypes';
import {notify} from '../../helpers/utility';

// 1. get Transferable Agents
export const getTransferableAgentsStart = () => {
  return {
    type: actionTypes.GET_TRANSFERABLE_AGENTS_START,
  };
};

export const getTransferableAgentsFail = (error) => {
  return {
    type: actionTypes.GET_TRANSFERABLE_AGENTS_FAIL,
    error: error,
  };
};

export const getTransferableAgentsSuccess = (agentId, transferableAgents) => {
  return {
    type: actionTypes.GET_TRANSFERABLE_AGENTS_SUCCESS,
    transferableAgents: transferableAgents,
  };
};

export const getTransferableAgents = (agentId,campaignName,skillId) => {
  return (dispatch) => {
    dispatch(getTransferableAgentsStart());
    //console.log(campaignName,skillId);
    ctiRequest['CTI_TRANSFERABLE_AGENT'].agent_id = agentId;
    ctiRequest['CTI_TRANSFERABLE_AGENT'].campaign_name = campaignName;
    ctiRequest['CTI_TRANSFERABLE_AGENT'].skill_id = skillId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_TRANSFERABLE_AGENT'].ip = window.clientIP;
  
    axios
      .post('/', ctiRequest['CTI_TRANSFERABLE_AGENT'])
      .then((result) => {
        //console.log(result.data);
        if (result.data.response.status === 'SUCCESS') {
          dispatch(getTransferableAgentsSuccess(agentId, result.data.response.online_agents));
        } else {
          notify('Agent Transfer Error: ' + result.data.response.reason, 'call-transfer');
          dispatch(getTransferableAgentsFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Agent Transfer Error', 'call-transfer');
        dispatch(getTransferableAgentsFail(err));
      });
  };
};

// 2. get Transferable Campaign
export const getTransferableCampaignStart = () => {
  return {
    type: actionTypes.GET_TRANSFERABLE_CAMPAIGN_START,
  };
};

export const getTransferableCampaignFail = (error) => {
  return {
    type: actionTypes.GET_TRANSFERABLE_CAMPAIGN_FAIL,
    error: error,
  };
};

export const getTransferableCampaignSuccess = (agentId, transferableCampaign) => {
  return {
    type: actionTypes.GET_TRANSFERABLE_CAMPAIGN_SUCCESS,
    transferableCampaign: transferableCampaign,
  };
};

export const getTransferableCampaign = (agentId) => {
  return (dispatch) => {
    dispatch(getTransferableCampaignStart());
    ctiRequest['CTI_TRANSFERABLE_CAMPAIGNS'].agent_id = agentId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_TRANSFERABLE_CAMPAIGNS'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_TRANSFERABLE_CAMPAIGNS'])
      .then((result) => {
      
        if (result.data.response.status === 'SUCCESS') {
          dispatch(getTransferableCampaignSuccess(agentId, result.data.response.campaign));
        } else {
          notify('Campaign Transfer Error: ' + result.data.response.reason, 'call-transfer');
          dispatch(getTransferableCampaignFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Campaign Transfer Error', 'call-transfer');
        dispatch(getTransferableCampaignFail(err));
      });
  };
};

// 3. get Transferable Skill
export const getTransferableSkillStart = () => {
  return {
    type: actionTypes.GET_TRANSFERABLE_SKILL_START,
  };
};

export const getTransferableSkillFail = (error) => {
  return {
    type: actionTypes.GET_TRANSFERABLE_SKILL_FAIL,
    error: error,
  };
};

export const getTransferableSkillSuccess = (agentId, transferableSkills) => {
  return {
    type: actionTypes.GET_TRANSFERABLE_SKILL_SUCCESS,
    transferableSkills: transferableSkills,
  };
};

export const getTransferableSkill = (agentId, campaignName) => {
  return (dispatch) => {
    dispatch(getTransferableSkillStart());
    ctiRequest['CTI_GET_CAMPAIGN_SKILLS'].agent_id = agentId;
    ctiRequest['CTI_GET_CAMPAIGN_SKILLS'].campaign_name = campaignName;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_GET_CAMPAIGN_SKILLS'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_GET_CAMPAIGN_SKILLS'])
      .then((result) => {
        //console.log(result.data);
        if (result.data.response.status === 'SUCCESS') {
          dispatch(getTransferableSkillSuccess(agentId, result.data.response.skills));
        } else {
          notify('Skill Error: ' + result.data.response.reason, 'call-transfer');
          dispatch(getTransferableSkillFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Skill Error', 'call-transfer');
        dispatch(getTransferableSkillFail(err));
      });
  };
};

// 4. get Transferable Extension
export const getTransferableExtensionStart = () => {
  return {
    type: actionTypes.GET_TRANSFERABLE_EXTENSION_START,
  };
};

export const getTransferableExtensionFail = (error) => {
  return {
    type: actionTypes.GET_TRANSFERABLE_EXTENSION_FAIL,
    error: error,
  };
};

export const getTransferableExtensionSuccess = (agentId, transferableExtension) => {
  return {
    type: actionTypes.GET_TRANSFERABLE_EXTENSION_SUCCESS,
    transferableExtension: transferableExtension,
  };
};

export const getTransferableExtension = (agentId) => {
  return (dispatch) => {
    dispatch(getTransferableExtensionStart());
    ctiRequest['CTI_GET_EXTENSION'].agent_id = agentId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_GET_EXTENSION'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_GET_EXTENSION'])
      .then((result) => {
        //console.log(result.data);
        if (result.data.response.status === 'SUCCESS') {
          dispatch(getTransferableExtensionSuccess(agentId, result.data.response.extensions));
        } else {
          notify('Extension Transfer Error: ' + result.data.response.reason, 'call-transfer');
          dispatch(getTransferableExtensionFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Extension Transfer Error', 'call-transfer');
        dispatch(getTransferableExtensionFail(err));
      });
  };
};

// 5. Transfer Agent
export const transferAgentStart = () => {
  return {
    type: actionTypes.TRANSFER_AGENT_START,
  };
};

export const transferAgentFail = (error) => {
  return {
    type: actionTypes.TRANSFER_AGENT_FAIL,
    error: error,
  };
};

export const transferAgentSuccess = (agentId, transferTo) => {
  return {
    type: actionTypes.TRANSFER_AGENT_SUCCESS,
    transferMsg: transferTo,
  };
};

export const transferAgent = (agentId, transferTo) => {
  return (dispatch) => {
    dispatch(transferAgentStart());
    ctiRequest['CTI_TRANSFER_AGENT'].agent_id = agentId;
    ctiRequest['CTI_TRANSFER_AGENT'].transfer_to = transferTo;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_TRANSFER_AGENT'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_TRANSFER_AGENT'])
      .then((result) => {
        //console.log(result.data);
        if (result.data.response.status === 'SUCCESS') {
          dispatch(transferAgentSuccess(agentId, transferTo));
        } else {
          notify('Agent Transfer Error: ' + result.data.response.reason, 'call-transfer');
          dispatch(transferAgentFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Agent Transfer Error', 'call-transfer');
        dispatch(transferAgentFail(err));
      });
  };
};

// 6. Transfer Campaign
export const transferCampaignStart = () => {
  return {
    type: actionTypes.TRANSFER_CAMPAIGN_START,
  };
};

export const transferCampaignFail = (error) => {
  return {
    type: actionTypes.TRANSFER_CAMPAIGN_FAIL,
    error: error,
  };
};

export const transferCampaignSuccess = (agentId) => {
  return {
    type: actionTypes.TRANSFER_CAMPAIGN_SUCCESS,
  };
};

export const transferCampaign = (agentId, transferCampaignName, skillFlag, skill) => {
  return (dispatch) => {
    dispatch(transferCampaignStart());
    ctiRequest['CTI_TRANSFER_CAMPAIGN'].agent_id = agentId;
    ctiRequest['CTI_TRANSFER_CAMPAIGN'].transfer_campaign_name = transferCampaignName;
    ctiRequest['CTI_TRANSFER_CAMPAIGN'].skill_transfer_flag = skillFlag;
    ctiRequest['CTI_TRANSFER_CAMPAIGN'].skill = skill;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_TRANSFER_CAMPAIGN'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_TRANSFER_CAMPAIGN'])
      .then((result) => {
        //console.log(result.data);
        if (result.data.response.status === 'SUCCESS') {
          dispatch(transferCampaignSuccess(agentId));
        } else {
          notify('Campaign Transfer Error: ' + result.data.response.reason, 'call-transfer');
          dispatch(transferCampaignFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Campaign Transfer Error', 'call-transfer');
        dispatch(transferCampaignFail(err));
      });
  };
};

// 7. Transfer Extension
export const transferExtensionStart = () => {
  return {
    type: actionTypes.TRANSFER_EXTENSION_START,
  };
};

export const transferExtensionFail = (error) => {
  return {
    type: actionTypes.TRANSFER_EXTENSION_FAIL,
    error: error,
  };
};

export const transferExtensionSuccess = (agentId) => {
  return {
    type: actionTypes.TRANSFER_EXTENSION_SUCCESS,
  };
};

export const transferExtension = (agentId, extensionId) => {
  return (dispatch) => {
    dispatch(transferExtensionStart());
    ctiRequest['CTI_TRANSFER_EXTENSION'].agent_id = agentId;
    ctiRequest['CTI_TRANSFER_EXTENSION'].extension_id = extensionId;
    window.clientIP = localStorage.getItem('clientIP') ? localStorage.getItem('clientIP') : '127.0.0.1';
    ctiRequest['CTI_TRANSFER_EXTENSION'].ip = window.clientIP;
    axios
      .post('/', ctiRequest['CTI_TRANSFER_EXTENSION'])
      .then((result) => {
        //console.log(result.data);
        if (result.data.response.status === 'SUCCESS') {
          dispatch(transferExtensionSuccess(agentId));
        } else {
          notify('Extension Transfer Error: ' + result.data.response.reason, 'call-transfer');
          dispatch(transferExtensionFail(result.data.response.reason));
        }
      })
      .catch((err) => {
        console.log(err);
        notify('Extension Transfer Error', 'call-transfer');
        dispatch(transferExtensionFail(err));
      });
  };
};

export const unsetTransferSuccess = (agentId) => {
  return {
    type: actionTypes.TRANSFER_UNSET_SUCCESS,
  };
};

export const unsetTransfer = (agentId) => {
  return (dispatch) => {
    dispatch(unsetTransferSuccess(agentId));
  };
};
